import { identity, pickBy } from 'lodash-es';
import generator from 'url-routes-generator';

// eslint-disable-next-line prefer-destructuring
const MONOLITH_DOMAIN = process.env.MONOLITH_DOMAIN; // cannot use destructure because it's a defineConfig

generator.defaults.baseURL = '/';
const gbmcGenerator = generator.create({ baseURL: `//${MONOLITH_DOMAIN}/x/gbmc/` });

export default {
  storefront: (subdomain: string) => `https://${subdomain}.${MONOLITH_DOMAIN}`,
  adminUserSession: (accountId: string, whitelabelSubdomain?: string) =>
    generator.build(`https://${MONOLITH_DOMAIN}/lit/admin_user_session/new`)(
      pickBy(
        {
          account_id: accountId,
          whitelabel_subdomain: whitelabelSubdomain,
        },
        identity
      )
    ),
  home: () => generator.build('/')(),
  login: () => generator.build('/login')(),
  resetPassword: () => generator.build('/reset')(),
  customer: (customerId?: string) => generator.build('/customers/:customerId', { customerId })(),
  customerOrders: (customerId?: string) =>
    generator.build('/customers/:customerId/orders', { customerId })(),
  customerOpenOrders: (customerId?: string) =>
    generator.build('/customers/:customerId/openOrders', { customerId })(),
  gbmc: {
    customers: (customerId: string) =>
      gbmcGenerator.build('/customers/:customerId', { customerId })(),
    orders: (orderId: string) => gbmcGenerator.build('/orders/:orderId', { orderId })(),
    subscription: (subscriptionId: string) =>
      gbmcGenerator.build('/subscriptions/:subscriptionId', { subscriptionId })(),
  },
  order: (orderId?: string) => generator.build('/orders/:orderId', { orderId })(),
  orderCancel: (orderId?: string) => generator.build('/orders/:orderId/cancel', { orderId })(),
  search: (params?: { query: string; model?: string }) => generator.build('/search')(params),
  suborder: (suborderId?: string) => generator.build('/suborders/:suborderId', { suborderId })(),
  suborderReship: (suborderId?: string) =>
    generator.build('/suborders/:suborderId/reship', { suborderId })(),
};
